import { useEffect } from 'react';

/** Держит экран включённым, пока открыта страница. */
export function useScreenWakeLock(): void {
  useEffect(() => {
    const nav = navigator as Navigator & {
      wakeLock?: { request: (type: 'screen') => Promise<{ release: () => Promise<void> }> };
    };
    if (!nav.wakeLock?.request) return;

    let lock: { release: () => Promise<void> } | null = null;
    let cancelled = false;

    const request = async () => {
      if (cancelled || document.visibilityState !== 'visible') return;
      try {
        lock = await nav.wakeLock!.request('screen');
      } catch {
        // Браузер может выдать lock только после жеста или полного экрана
      }
    };

    request();
    document.addEventListener('visibilitychange', request);
    document.addEventListener('fullscreenchange', request);
    document.addEventListener('pointerdown', request);
    return () => {
      cancelled = true;
      document.removeEventListener('visibilitychange', request);
      document.removeEventListener('fullscreenchange', request);
      document.removeEventListener('pointerdown', request);
      lock?.release().catch(() => undefined);
    };
  }, []);
}
